import { FILE_NAME_PREFIX_WP } from "../../constants/fileNamePrefix";

export const EXPORT_FILE_NAMES = {
  errorsFile: `${FILE_NAME_PREFIX_WP}Errors_File.xlsx`,
};
